import {
  UPDATE_CLAIM,
  CLEAR_CLAIM,

  BANKING_INFO_LOADING,
  BANKING_INFO_SUCCESS,
  BANKING_INFO_FAILED,

  SUBMIT_CLAIM_LOADING,
  SUBMIT_CLAIM_SUCCESS,
  SUBMIT_CLAIM_FAILED,

  GET_MVA_TYPES_LOADING,
  GET_MVA_TYPES_SUCCESS,
  GET_MVA_TYPES_FAILED
} from '../actions/submitAClaimActions'

const submitAClaim = (state = {
  claimObj: {},
  isLoading: false,
  error: null
}, action) => {
  switch (action.type) {
    case UPDATE_CLAIM:
      let claim = Object.assign({}, state.claimObj, action.claimObj)
      return Object.assign({}, state, {
        claimObj: claim
      })
    case CLEAR_CLAIM:
      return Object.assign({}, state, {
        claimObj: {}
      })
    case BANKING_INFO_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        banking: null,
        error: null
      })
    case BANKING_INFO_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        banking: action.response,
        error: null
      })
    case BANKING_INFO_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        banking: null,
        error: action.error
      })
    case SUBMIT_CLAIM_LOADING:
      return Object.assign({}, state, {
        isSubmitAClaimLoading: true,
        submitClaimResult: null,
        submitClaimError: null
      })
    case SUBMIT_CLAIM_SUCCESS:
      return Object.assign({}, state, {
        isSubmitAClaimLoading: false,
        submitClaimResult: action.response,
        submitClaimError: null,
        claimObj: { ...state.claimObj, ImageContent: [] }
      })
    case SUBMIT_CLAIM_FAILED:
      return Object.assign({}, state, {
        isSubmitAClaimLoading: false,
        submitClaimResult: null,
        submitClaimError: action.error
      })
    case GET_MVA_TYPES_LOADING:
      return Object.assign({}, state, {
        mvaTypesLoading: true,
        mvaTypesError: null,
        mvaTypes: []
      })
    case GET_MVA_TYPES_SUCCESS:
      return Object.assign({}, state, {
        mvaTypesLoading: false,
        mvaTypesError: null,
        mvaTypes: action.response
      })
    case GET_MVA_TYPES_FAILED:
      return Object.assign({}, state, {
        mvaTypesLoading: false,
        mvaTypesError: action.error,
        mvaTypes: []
      })
    default:
      return state
  }
}

export default submitAClaim



// WEBPACK FOOTER //
// ./src/redux/reducers/submitAClaimReducer.js